/**
 * DevExtreme (ui/data_grid/ui.data_grid.keyboard_navigation.js)
 * Version: 19.2.6
 * Build date: Thu Jan 30 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
"use strict";
var _uiData_grid = require("./ui.data_grid.core");
var _uiData_grid2 = _interopRequireDefault(_uiData_grid);
var _uiGrid_core = require("../grid_core/ui.grid_core.keyboard_navigation");
var _uiGrid_core2 = _interopRequireDefault(_uiGrid_core);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    }
}
_uiData_grid2.default.registerModule("keyboardNavigation", _uiGrid_core2.default);



//////////////////
// WEBPACK FOOTER
// ./~/devextreme/ui/data_grid/ui.data_grid.keyboard_navigation.js
// module id = 1070
// module chunks = 0